import React, {Component} from 'react'
import { Table } from 'react-bootstrap'
import './Cart.css'
import moment from "moment";
import {NavLink} from "react-router-dom";

export default class Cart extends Component {

    constructor(props) {
        super(props);
        this.calculateTotal = this.calculateTotal.bind(this);
    }

    calculateTotal() {
        let total = 0;
        for(let index in this.props.items) {
            const item = this.props.items[index];
            total = total + (item.ParkTicketType.price * item.quantity);
        }
        return total;
    }

    render() {
        return (
            <div className="col-md-offset-1 col-md-10">
                <div className="panel panel-default panel-border">
                    <div className="panel-body">
                        <NavLink to="/user-area" className="btn btn-green btn-lg-back">Torna indietro</NavLink>
                        <h2 className="title">Carrello</h2>

                        {this.props.items.length === 0 && <h3>Nessun Elemento presente nel carrello</h3>}
                        {this.props.items.length > 0 && <div className="row">

                            {this.props.items.map((item, index) => {
                                return (
                                    <div key={index} className="col-md-6">
                                        <div className="card-marks">
                                            <div className="capiton cart-caption">
                                                <h5><strong>Abbonamento: </strong>
                                                    <span className="text-left">
                                                {item.ParkTicketType.printLabel && <span>{item.ParkTicketType.printLabel && item.ParkTicketType.printLabel} {item.Mark && item.Mark.Category.label.toUpperCase()}</span>}
                                                        {!item.ParkTicketType.printLabel && <span>STANDARD</span>}
                                            </span>
                                                </h5>
                                                <h5><strong>Valido </strong>
                                                    <span className="text-left">
                                                <strong>dal </strong> <span>{moment(item.startDate).format('L')}</span>
                                                <strong> al </strong> {
                                                      item.ParkTicketType.monthly
                                                        ? moment(item.startDate).add(29 * item.quantity + (item.quantity - 1), 'days').format('L')
                                                        : item.ParkTicketType.halfYearly
                                                        ? moment(item.startDate).add(179 * item.quantity + (item.quantity - 1), 'days').format('L')
                                                        : item.ParkTicketType.daily
                                                          ? moment(item.startDate).add(1 * item.quantity, 'days').format('L')
                                                          : moment(item.startDate).add(6 * item.quantity + (item.quantity - 1), 'days').format('L')
                                                    }
                                            </span>
                                                </h5>
                                                {item.ParkTicketType.name.indexOf('standard') > 0 && <h5>
                                                    <strong>Zone: </strong>
                                                    <span>Tutte le zone</span>
                                                </h5>}
                                                {item.ParkTicketType.MarkTypeId && <h5>
                                                    <strong>Zon{item.ParkTicketType.MarkType.Areas.length > 1 ? "e" : "a"}: </strong>
                                                    <span>{item.ParkTicketType.MarkType.Areas.map(item => item.code + " ")}</span>
                                                </h5>}

                                                {item.Mark && <h5>
                                                    <strong>Targ{item.Mark.Vehicles.length > 0 ? 'he' : 'a'}: </strong>
                                                    <span>{item.Mark.Vehicles.map(item => item.plate_number.toUpperCase() + " ")}</span>
                                                </h5>}
                                                {!item.Mark && <h5>
                                                    <strong>Targa: </strong>
                                                    <span>{item.Vehicle.plate_number.toUpperCase()}</span>
                                                </h5>}
                                                <h5><strong>Prezzo </strong>
                                                    <span className="text-left"> {Number(item.ParkTicketType.price).toLocaleString("it-IT", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                                </h5>
                                                <div className="row display-flex">

                                                    <div className="col-xs-12 col-sm-1 col-md-6 col-lg-6">
                                                        <label>Quantit&agrave;:</label>
                                                        <div className="input-group">
                                                            <span className="input-group-btn">
                                                                <button onClick={() => this.props.removeItemQuantity(item)} type="button" className="btn btn-default btn-number">
                                                                    <span className="glyphicon glyphicon-minus">{}</span>
                                                                </button>
                                                            </span>
                                                            <span className="form-control" style={{padding: '6px', verticalAlign: 'middle', display: 'inline-block', textAlign: 'center'}}>
                                                                {item.quantity}
                                                            </span>
                                                            <span className="input-group-btn">
                                                                <button onClick={() => this.props.addItemQuantity(item)} type="button" className="btn btn-default btn-number">
                                                                    <span className="glyphicon glyphicon-plus">{}</span>
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-xs-12 text-center">
                                                        <button style={{position: 'absolute', bottom: '3px', left: '10px'}} onClick={() => this.props.removeItem(item)} type="button" className="btn btn-sm btn-add-1 hidden-xs hidden-sm">
                                                            <span className="glyphicon glyphicon-remove">{}</span> Rimuovi
                                                        </button>
                                                        <button style={{marginTop: '15px'}} onClick={() => this.props.removeItem(item)} type="button" className="btn btn-sm btn-add-1 hidden-md hidden-lg">
                                                            <span className="glyphicon glyphicon-remove">{}</span> Rimuovi
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>);
                            })}
                        </div>}






                        {/*<Table responsive>
                            <thead>
                            <tr>
                                <th>Prodotto</th>
                                <th>ValiditÃ </th>
                                <th>Prezzo</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td className="text-left">Nome Prodotto</td>
                                <td className="text-left"><strong>Dal</strong> 10/11/17
                                    <span> </span>
                                    <strong>al</strong> 17/11/17
                                </td>
                                <td className="text-left">Euro</td>
                                <td>
                                    <button type="button" className="btn btn-xs btn-add-1">
                                        <span className="glyphicon glyphicon-remove"></span> Rimuovi
                                    </button>
                                    <button type="button" className="btn btn-xs btn-add-2">
                                        <span className="glyphicon glyphicon-plus"></span> Duplica
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </Table>*/}

                        {this.props.items.length > 0 && <div className="row">
                            <div className="text-center">
                                <h3>Totale: € {Number(this.calculateTotal()).toLocaleString("it-IT", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
                            </div>
                        </div>}
                        {this.props.items.length > 0 && <button onClick={() => this.props.onCheckoutClick()} type="button" className="btn btn-primary btn-green">
                            Procedi con l'acquisto
                        </button>}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/UserArea/Cart/Cart.js